// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"Ln","red":"Mn","calloutlink":"Nn","headerTopBanner":"On","bgcolorRed":"Pn","headerTopCallout":"Qn","searchBanner":"Rn","hideMobile":"Sn"};